import { createSlice } from '@reduxjs/toolkit';
import * as actionTypes from '../actions/actionTypes';

export const getInitialState = () => ({
	managedProjectsIsLoading: false,
	managedProjectsHasErrored: false,
	data: [],
	authenticated: false
});

export const managedProjectsSlice = createSlice({
	name: 'managedProjects',
	initialState: getInitialState(),
	extraReducers: (builder) => {
		builder
			.addCase(actionTypes.MANAGEDPROJECTS_HAS_ERRORED, (state) => {
				state.managedProjectsIsLoading = false;
				state.managedProjectsHasErrored = true;
			})
			.addCase(actionTypes.MANAGEDPROJECTS_IS_LOADING, (state) => {
				state.managedProjectsIsLoading = true;
			})
			.addCase(actionTypes.MANAGEDPROJECTS_FETCH_DATA_SUCCESS, (state, action) => {
				state.managedProjectsIsLoading = false;
				state.data = action.response;
				state.authenticated = action.authenticated || false;
			});
	}
});

export const managedProjectsReducer = managedProjectsSlice.reducer;